import React, { Component } from 'react';
import './LatestNews.css';
import Fade from 'react-reveal/Fade';
import Blog2 from '../Blog2/Blog';


class latestnews extends Component {
    render() {
        return (
            <div className="latestnews">
                <div className="container-fluid bg-1">
                    <p className="main"><Fade delay={300}>
                        Latest News
                        </Fade></p>
                    <Blog2 className="blog-slider" />
                </div>
            </div>
        )
    }
}

export default latestnews;